import { render, staticRenderFns } from "./busWitnessCard.vue?vue&type=template&id=25c8bb45&scoped=true"
import script from "./busWitnessCard.vue?vue&type=script&lang=js"
export * from "./busWitnessCard.vue?vue&type=script&lang=js"
import style0 from "./busWitnessCard.vue?vue&type=style&index=0&id=25c8bb45&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c8bb45",
  null
  
)

export default component.exports